var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { copyToClipboard, checkDevice, ttfb, } from "@total_onion/onion-library/onion-utils.mjs";
import lazyloaderV3 from "@total_onion/onion-library/onion-loader";
import modalController from "@total_onion/onion-modalcontroller";
import jsAssets from "Assets/js/modules/jsAssets";
import shop from "Assets/js/modules/shop";
import customForms from "Assets/js/modules/customForms.mjs";
let shopJs = () => {
    var _a;
    const loadEShop = ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.dataset.eshopshopify) === "true";
    if (loadEShop == true) {
        shop.shopShopify(true);
        shop.checkCart(); // eager-loading Shopify?
    }
};
let runLazyLoadV3 = () => {
    lazyloaderV3.options.projectAssets = jsAssets.dynamicAssets;
    // lazyloaderV3.options.debugLogMessages = true;
    lazyloaderV3.lazyloaderInit();
};
function enableModalController() {
    const popupController = new modalController();
    popupController.setGlobalSettings({
        closeDelay: 500,
        closingClass: "modal-closing",
        addCloseButton: false,
    });
}
function yieldToMain() {
    return new Promise((resolve) => {
        setTimeout(resolve, 0);
    });
}
let runForm = () => {
    const modalForm = document.querySelector('.modal-form-v3 .cdb_form_container');
    if (!modalForm) {
        return;
    }
    const options = { block: modalForm };
    customForms(options);
};
window.addEventListener("DOMContentLoaded", () => {
    function runSiteJs() {
        return __awaiter(this, void 0, void 0, function* () {
            const tasks = [
                ttfb,
                checkDevice,
                copyToClipboard,
                runLazyLoadV3,
                enableModalController,
                shopJs,
                runForm,
            ];
            while (tasks.length > 0) {
                const task = tasks.shift();
                task();
                yield yieldToMain();
            }
        });
    }
    runSiteJs();
});
